import axios from '../../../axiosConfig';

export async function getAccounts(config = {}, clientId) {
    return await axios.get(`/v1/chart-of-account/all/${clientId}`, config);
}

export async function createChartOfAccount(data, config = {}) {
    return await axios.post(`/v1/chart-of-account`, data, config);
}

export async function getChartOfAccountById(id, config = {}) {
    return await axios.get(`/v1/chart-of-account/${id}`, config);
}

export async function updateChartOfAccount(data, config = {}) {
    return await axios.put(`/v1/chart-of-account/${data.id}`, data, config);
}

export async function deleteChartOfAccount(accountId, config = {}) {
    return await axios.delete(`/v1/chart-of-account/${accountId}`, config);
}

export async function getAccountsSimple(clientId, config = {}) {
    return await axios.get(`/v1/chart-of-account/${clientId}/simple`, config);
}

const functions = { getAccounts, getAccountsSimple, getChartOfAccountById, createChartOfAccount, updateChartOfAccount, deleteChartOfAccount }
export default functions
